var map = {
	"./number-1.svg": 794,
	"./number-2.svg": 795,
	"./number-3.svg": 796,
	"./number-4.svg": 797,
	"./number-5.svg": 798,
	"./number-6.svg": 799,
	"./number-7.svg": 800,
	"./number-8.svg": 801,
	"./number-9.svg": 802,
	"./number-shine-1.svg": 803,
	"./number-shine-2.svg": 804,
	"./number-shine-3.svg": 805,
	"./number-shine-4.svg": 806,
	"./number-shine-5.svg": 807,
	"./number-shine-6.svg": 808,
	"./number-shine-7.svg": 809,
	"./number-shine-8.svg": 810,
	"./number-shine-9.svg": 811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 793;